import { useLocation, useParams } from "react-router-dom";
import AdminHeader from "../../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../../Components/AdminNav/AdminNav";
import React, { useEffect, useState } from "react";
import { getCustomNewsOrder, updateCustomNewsOrder } from "../../../actions/NewsPages";

function EditOrder() {
    const location = useLocation();
    const user = location.state?.user;
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [components, setComponents] = useState<any[]>([]);
    const [saving, setSaving] = useState(false);

    const { id } = useParams<{ id?: string }>();

    useEffect(() => {
        fetchComponents();
    }, []);

    function fetchComponents() {
        if (id) {
            getCustomNewsOrder(Number(id))
                .then(response => {
                    setComponents(response.data.components);
                })
                .catch(error => {
                    console.error("Failed to fetch components:", error);
                });
        }
    }

    function getComponentName(component: string) {
        switch (component) {
            case 'body': return "Body Text";
            case 'image': return "Image";
            case 'gallery4': return "4 Image Gallery";
            case 'gallery': return "Gallery";
            case 'table': return "Table";
            case "imageText": return "Image then Text";
            case "textImage": return "Text then Image";
            default: return component;
        }
    }

    function updateOrder() {
        if (!id || saving) return;

        const payload = components.map(c => ({
            id: c.id,
            display_order: Number(c.display_order),
        }));

        setSaving(true);

        updateCustomNewsOrder(Number(id), payload)
            .then(() => {
                alert("Order updated successfully!");
                fetchComponents(); // refresh components after update
            })
            .catch(err => {
                console.error("Failed to update order:", err);
                alert("Failed to update order");
            })
            .finally(() => setSaving(false));
    }

    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />
            <div className={`main-admin-page ${isCollapsed ? "collapsed" : "expanded"}`}>
                <div>
                    <table className="news-table">
                        <thead>
                        <tr>
                            <th style={{ width: "80%" }}>Component</th>
                            <th style={{ width: "20%" }}>Order</th>
                        </tr>
                        </thead>
                        <tbody>
                        {components.map((component) => (
                            <tr key={component.id}>
                                <td>{getComponentName(component.component_type)}</td>
                                <td>
                                    <input
                                        type="number"
                                        value={component.display_order}
                                        onChange={(e) => {
                                            const newComponents = [...components];
                                            const index = newComponents.findIndex(c => c.id === component.id);
                                            newComponents[index].display_order = Number(e.target.value);
                                            setComponents(newComponents);
                                        }}
                                    />
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    <button
                        onClick={updateOrder}
                        disabled={saving}
                        style={{
                            marginTop: "20px",
                            padding: "8px 16px",
                            cursor: saving ? "not-allowed" : "pointer"
                        }}
                    >
                        {saving ? "Saving..." : "Save Order"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default EditOrder;
